import Raccourcis from '../../../../../components/raccourcis/raccourcis';
import { GlobalProvider } from "../../../../../utils/globalprovider.js";

import React from 'react';
import './commonraccourcis.css'
import { GetIsFTVAChrome } from '../../../../../utils/software.js';
import Dialog from '../../../../dialogs/dialog';
import { keyboard_multi_getPersonnalKey } from '../../../../../utils/keyboard_multi.js';


class CommonRaccourcis extends Dialog {
  constructor(props) {
    super(props);


    var chromium= GetIsFTVAChrome();
    if (chromium !== "")
      chromium = " (" + chromium + ")";
    
    const title = {
      fr: "Programmation des touches" + chromium,
      en: "Programming keys + chromium",
    };

    this.state.title = title;

    this.state.buttons =
      [
        { type: 'text', disavled: false, text: { fr: 'Réinitialiser', en: 'Reset shortcuts' }, key: "reset" },
        { type: 'text', disabled: false, text: { fr: "Import JSON", en: 'JSON import' }, key: "importJSON" },
        { type: 'text', disabled: false, text: { fr: "Export TXT", en: 'TXT export' }, key: "exportTXT" },
        { type: 'text', disabled: false, text: { fr: "Export JSON", en: 'JSON export' }, key: "exportJSON" },
        { type: 'text', disabled: false, text: { fr: "Export CSV", en: 'CSV export' }, key: "exportCSV" },
        { type: "text", disabled: false, text: { fr: "Sauvegarder", en: "Save" }, key: "save" },
        { type: "back", disabled: false },
      ]
    
    this.handleButton = this.handleButton.bind(this);

    this.onQuit = this.onQuit.bind(this);
    this.onImportJson = this.onImportJson.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.raccourcisRef = React.createRef();
  }

  componentDidMount() {
    super.componentDidMount();

    if (this.raccourcisRef && this.raccourcisRef.current) {      
      const listeShortcuts = keyboard_multi_getPersonnalKey();
      this.raccourcisRef.current.setRaccourcis(listeShortcuts);
    }
  }

  onQuit() {

    if (this.raccourcisRef.current.getIsUpdated()) {
      this.raccourcisRef.current.showPopup({
          display: true,
          title: '',
          text: {
            fr: 'Voulez-vous sauvegarder avant de quitter ?',
            en: 'Do you want to save before you leave?'              
          },
          buttons: [ {
              text: {
                fr: 'Oui',
                en: 'Yes',
              },
              onclick: () => {
               const items = this.raccourcisRef.current.getItems();
                this.props.onButton({ name: "save", items });
              },
            },
            {
              text: {
                fr: 'Non',
                en: 'No',
              },
              onclick: () => {
                this.raccourcisRef.current.hidePopup();
                this.props.onButton({ name: "back" });
              },
            }],
          icon: null,
          showIcon: true,
        });

      return;
    }

    this.props.onButton({ name: "back" });
  }

  handleButton(buttonkey) {
    console.log("on click", buttonkey)

    switch (buttonkey) {
      case "back":
        this.onQuit();
        break;
      
      case "save":
        const items = this.raccourcisRef.current.getItems();
        this.props.onButton({ name: "save", items });
        break;
      
      case "exportTXT":
        this.raccourcisRef.current.exportText();
        break;
      
      case "exportCSV":
        this.raccourcisRef.current.exportCSV();
        break;
       case "exportJSON":
        this.raccourcisRef.current.exportJson();
        break;
      
      case "importJSON":
        this.onImportJson();    
        break;
      
      case "reset":
        this.raccourcisRef.current.showPopup({
          display: true,
          title: '',
          text: {
            fr: 'Voulez-vous réinitialiser les raccourcis ?',
            en: 'Do you want to reset the shortcuts?',
          },
          buttons: [
            {
              text: {
                fr: 'Oui',
                en: 'Yes',
              },
              onclick: () => {                
                const defaultListeShortcuts = keyboard_multi_getPersonnalKey(true);                
                this.raccourcisRef.current.setRaccourcis(defaultListeShortcuts, true);
                this.raccourcisRef.current.hidePopup();
              },
            },
            {
              text: {
                fr: 'Non',
                en: 'No',
              },
              onclick: () => this.raccourcisRef.current.hidePopup(),
            },
          ],
          icon: null,
          showIcon: true,
        });
        break;
      
      default:
        return;
    }


  }

  handleKeyDown = (event) => {     
    super.handleKeyDown(event);
    
    if (this.raccourcisRef && this.raccourcisRef.current) {
      this.raccourcisRef.current.onKeyDown(event);
    }
  }

  onImportJson = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    input.onchange = (event) => {
      const file = event.target.files[0];

      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const jsonData = JSON.parse(reader.result);
            this.raccourcisRef.current.setRaccourcis(jsonData, true);
          } catch (error) {
            console.error('Invalid JSON file:', error);
          }
        };
        reader.readAsText(file);

      };
    }
    
    input.click();
  }

  render() {

    var maxheight = (window.innerHeight * 82) / 100;
    if (maxheight > 500) maxheight = 500;

    const retour =
      (
        <div style={{ height: maxheight }}>
          <div className="divcommonraccourcis">
            <GlobalProvider>
              <Raccourcis ref={this.raccourcisRef} onSave={this.onSave} default={this.props.default} />
            </GlobalProvider>
          </div>
        </div>
      )

    return super.render(retour);
  }
}

export default CommonRaccourcis